
import { getDetallePaqueteReferencia, getPenalizacionCancelacionPaquete, putCambioFechaCliente, putCancelacionPaquete } from "../services/servicePaquete";
import { putPsajeroDelete, postPenalizacionAddPasajero, postPasajeroAdd, getPasajeros, getSolicitudesPasajeros, putPasajeroAcept, putPasajeroDecline, postPenalizacionDeletePasajero } from "./../services/passengerService"
import { FormatoDiff } from "../utils/FormatFecha";
import { getContratacionReferencia } from "../services/contratacionService"
import { getComprasItemsPaquete } from "../services/comprasService";

const dataInicial = {
  cliente: {},
  referencia: "",
  accion: 0,
  exito: 0,
  viaje: {},
  diasRestantes: 0,
  penalizacionCancel: {},
  penalizacion: {},
  estatusProceso: {},
  isCancelacion: false,
  pasajeros: {},
  solicitudesPasajeros: {},
  tapCambioPasajero: 0,
  cotizacion: {},
  compras: []
};

const SELECT_CAMBIOS_CLIENTE = "SELECT_CAMBIOS_CLIENTE"
const GET_CAMBIOS_COMPRAS = "GET_CAMBIOS_COMPRAS"
const GET_CAMBIOS_VIAJE_REFERENCIA = "GET_CAMBIOS_VIAJE_REFERENCIA"
const GET_CAMBIOS_COTIZACION = "GET_CAMBIOS_COTIZACION"
const SEELCT_CAMBIOS_ACCION = "SEELCT_CAMBIOS_ACCION"
const CANCELAR_PAQUETE_CAMBIOS = "CANCELAR_PAQUETE_CAMBIOS"
const CONSULTA_PENALIZACIONES_CAMBIOS = "CONSULTA_PENALIZACIONES_CAMBIOS"
const POST_CAMBIOS_FECHA_SALIDA = "POST_CAMBIOS_FECHA_SALIDA"
const GET_CAMBIOS_CANCELACION = "GET_CAMBIOS_CANCELACION"
const PUT_CAMBIOS_CANCELACION = "PUT_CAMBIOS_CANCELACION"
const PUT_CAMBIOS_CAMBIO_FECHA = "PUT_CAMBIOS_CAMBIO_FECHA"
const SELECT_CAMBIOS_CANCELACION = "SELECT_CAMBIOS_CANCELACION"
const POST_CAMBIOS_PASAJERO_ADD_PENALITY = "POST_CAMBIOS_PASAJERO_ADD_PENALITY"
const POST_CAMBIOS_PASAJERO_REMOVE_PENALITY = "POST_CAMBIOS_PASAJERO_REMOVE_PENALITY"
const POST_CAMBIOS_PASAJERO_ADD = "POST_CAMBIOS_PASAJERO_ADD"
const POST_CAMBIOS_PASAJERO_REMOVE = "POST_CAMBIOS_PASAJERO_REMOVE"
const GET_CAMBIOS_PASAJEROS = "GET_CAMBIOS_PASAJEROS"
const GET_CAMBIOS_PASAJEROS_SOLICITUDES = "GET_CAMBIOS_PASAJEROS_SOLICITUDES"
const PUT_CAMBIOS_PASAJERO_DISPONIBLE = "PUT_CAMBIOS_PASAJERO_DISPONIBLE"
const PUT_CAMBIOS_PASAJERO_NO_DISPONIBLE = "PUT_CAMBIOS_PASAJERO_NO_DISPONIBLE"
const CHANGE_CAMBIOS_PASAJERO_TAP = "CHANGE_CAMBIOS_PASAJERO_TAP"
const CLEAR_STATE = "CLEAR_STATE"

export default function cambiosReducer(state = dataInicial, action) {
  switch (action.type) {
    case GET_CAMBIOS_COMPRAS:
      return { ...state, compras: action.payload.compras }
    case GET_CAMBIOS_COTIZACION:
      return { ...state, cotizacion: action.payload.cotizacion }
    case CHANGE_CAMBIOS_PASAJERO_TAP:
      return { ...state, tapCambioPasajero: action.payload.tapCambioPasajero} 
    case PUT_CAMBIOS_PASAJERO_DISPONIBLE:
      return { ...state, exito: action.payload.exito }
    case PUT_CAMBIOS_PASAJERO_NO_DISPONIBLE:
      return { ...state, exito: action.payload.exito }
    case GET_CAMBIOS_PASAJEROS_SOLICITUDES: 
      return { ...state, solicitudesPasajeros: action.payload.solicitudesPasajeros }
    case GET_CAMBIOS_PASAJEROS:
      return { ...state, pasajeros: action.payload.pasajeros }
    case POST_CAMBIOS_PASAJERO_ADD_PENALITY:
      return { ...state, penalizacion: action.payload.penalizacion }
    case POST_CAMBIOS_PASAJERO_REMOVE_PENALITY:
      return { ...state, penalizacion: action.payload.penalizacion }
    case POST_CAMBIOS_PASAJERO_ADD:
      return { ...state, exito: action.payload.exito }
    case POST_CAMBIOS_PASAJERO_REMOVE:
      return { ...state, exito: action.payload.exito }
    case PUT_CAMBIOS_CAMBIO_FECHA:
      return { ...state, exito: action.payload.exito }
    case SELECT_CAMBIOS_CANCELACION:
      return { ...state, isCancelacion: action.payload.isCancelacion }
    case GET_CAMBIOS_VIAJE_REFERENCIA:
      return { ...state, viaje: action.payload.viaje, estatusProceso: action.payload.estatusProceso }
    case PUT_CAMBIOS_CANCELACION:
      return { ...state, exito: action.payload.exito }
    case GET_CAMBIOS_CANCELACION:
      return { ...state, penalizacionCancel: action.payload.penalizacionCancel }
    case POST_CAMBIOS_FECHA_SALIDA:
      return { ...state, exito: action.payload.exito }
    case CONSULTA_PENALIZACIONES_CAMBIOS:
      return { ...state, penalizacion: action.payload.penalizacion }
    case CANCELAR_PAQUETE_CAMBIOS:
      return { ...state, exito: action.payload.exito }
    case SEELCT_CAMBIOS_ACCION:
      return { ...state, accion: action.payload.accion }
    case SELECT_CAMBIOS_CLIENTE:
      return {
        ...state,
        cliente: action.payload.cliente,
        referencia: action.payload.referencia,
        viaje: action.payload.viaje,
        estatusProceso: action.payload.estatusProceso,
        diasRestantes: action.payload.diasRestantes
      }
    case CLEAR_STATE:
      return {
        ...state,
        cliente: action.payload.cliente,
      };
    default:
      return state;
  }
}

export const changeCambioPasajeroTapAction = ({ tapValue }) => (dispatch) => {
  dispatch({
    type: CHANGE_CAMBIOS_PASAJERO_TAP,
    payload: {
      tapCambioPasajero: tapValue
    }
  })
}

export const selectIsCancelacionAction = ({ isCancelacion }) => (dispatch) => {
  dispatch({
    type: SELECT_CAMBIOS_CANCELACION,
    payload: {
      isCancelacion
    }
  })
}

export const obtenerPenalizacionAction = ({ idPaquete, Accion }) => async (dispatch) => {
  dispatch({
    type: CONSULTA_PENALIZACIONES_CAMBIOS,
    payload: {
      penalizacion: []
    }
  })
}

export const accionTargetAction = ({ accion }) => async (dispatch) => {
  dispatch({
    type: SEELCT_CAMBIOS_ACCION,
    payload: {
      accion
    }
  })
}
export const consultaDetalleViajeAction = () => async (dispatch, getState) => {
  const {cliente, referencia} = getState().cambios
  return await getDetallePaqueteReferencia({ Referencia: referencia }).then(Response => {
    if (Response.status === 500 || Response.status === 400) {
      dispatch({
        type: SELECT_CAMBIOS_CLIENTE,
        payload: {
          cliente,
          referencia,
          viaje: {},
          estatusProceso: {},
        }
      })
      return Response
    }
    dispatch({
      type: SELECT_CAMBIOS_CLIENTE,
      payload: {
        cliente,
        referencia,
        viaje: Response,
        estatusProceso: Response?.Paquete?.CatEstatusProceso,
        diasRestantes: FormatoDiff({ date: Response?.Paquete?.Fecha_Viaje }),
      }
    })
    return Response
  })
}
export const clienteTargetAction = ({ cliente, referencia }) => async (dispatch) => {
  return await getDetallePaqueteReferencia({ Referencia: referencia }).then(Response => {
    if (Response.status === 500 || Response.status === 400) {
      dispatch({
        type: SELECT_CAMBIOS_CLIENTE,
        payload: {
          cliente,
          referencia,
          viaje: {},
          estatusProceso: {},
        }
      })
      return Response
    }
    dispatch({
      type: SELECT_CAMBIOS_CLIENTE,
      payload: {
        cliente,
        referencia,
        viaje: Response,
        estatusProceso: Response?.Paquete?.CatEstatusProceso,
        diasRestantes: FormatoDiff({ date: Response?.Paquete?.Fecha_Viaje }),
      }
    })
    return Response
  })
}
export const obtnerViajeRefenciaAction = () => async (dispatch, getState) => {
  const { referencia } = getState().cambios
  return await getDetallePaqueteReferencia({ Referencia: referencia }).then(Response => {
    dispatch({
      type: GET_CAMBIOS_VIAJE_REFERENCIA,
      payload: {
        viaje: Response,
        estatusProceso: Response?.Paquete?.CatEstatusProceso,
      }
    })
    return Response
  })
}
/***
 * TODO: Cambio de fecha
 */
export const aplicarCambioFecha = ({ IdPaquete, IdBloqueSalida, IdObjeto }) => async (dispatch) => {
  return await putCambioFechaCliente({ IdPaquete, IdBloqueSalida, IdObjeto }).then(Response => {
    dispatch({
      type: GET_CAMBIOS_CANCELACION,
      payload: {
        penalizacionCancel: Response
      }
    })
    return Response
  })
}
/**
 *  TODO: Cancelaciones de paquete
 */
export const obtenerPenalizacionCancelacion = ({ IdPaquete }) => async (dispatch) => {
  return await getPenalizacionCancelacionPaquete({ IdPaquete }).then(Response => {
    dispatch({
      type: GET_CAMBIOS_CANCELACION,
      payload: {
        penalizacionCancel: Response
      }
    })
    return Response
  })
}
export const cancelarPaqueteAction = ({ IdPaquete }) => async (dispatch) => {
  return await putCancelacionPaquete({ IdPaquete }).then(Response => {
    dispatch({
      type: PUT_CAMBIOS_CANCELACION,
      payload: {
        exito: 1
      }
    })
    return Response
  })
}
/**
 *  TODO: Cambios de pasajeros
 */

export const consultaPasajerosAction = ({ IdPaquete }) => async (dispatch) => {
  return await getPasajeros({ IdPaquete }).then(Response => {
    dispatch({
      type: GET_CAMBIOS_PASAJEROS,
      payload: {
        pasajeros: Response
      }
    })
    return Response
  }).catch(Error => {
    return Error
  })
}
export const consultaPenalizacionAddPasajeroAction = ({ IdPaquete, Adultos, Infantes, Menores }) => async (dispatch) => {
  return await postPenalizacionAddPasajero({ IdPaquete, Adultos, Infantes, Menores }).then(Response => {
    dispatch({
      type: POST_CAMBIOS_PASAJERO_ADD_PENALITY,
      payload: {
        penalizacion: Response
      }
    })
    return Response
  }).catch(Error => {
    return Error
  })
}
export const consultaPenalizacionRemovePasajeroAction = ({ IdPaquete, Adultos, Infantes, Menores }) => async (dispatch) => {
  return await postPenalizacionDeletePasajero({ IdPaquete, Adultos, Infantes, Menores }).then(Response => {
    dispatch({
      type: POST_CAMBIOS_PASAJERO_REMOVE_PENALITY,
      payload: {
        penalizacion: Response
      }
    })
    return Response
  }).catch(Error => {
    return Error
  })
}

export const AddPasajeroAction = ({ IdPaquete, Adultos, Infantes, Menores }) => async (dispatch) => {
  return await postPasajeroAdd({ IdPaquete, Adultos, Infantes, Menores }).then(Response => {
    dispatch({
      type: POST_CAMBIOS_PASAJERO_ADD,
      payload: {
        exito: 1
      }
    })
    return Response
  })
}
export const RemovePasajeroAction = ({ IdPaquete, Adultos, Infantes, Menores }) => async (dispatch) => {
  return await putPsajeroDelete({ IdPaquete, Adultos, Infantiles: Infantes, Menores }).then(Response => {
    dispatch({
      type: POST_CAMBIOS_PASAJERO_REMOVE,
      payload: {
        exito: 1
      }
    })
    return Response
  })
}
export const consultaSolicitudesPasajeroAction = ({ IdPaquete }) => async (dispatch) => {
  return await getSolicitudesPasajeros({ IdPaquete }).then(Response => {
    dispatch({
      type: GET_CAMBIOS_PASAJEROS_SOLICITUDES,
      payload: {
        solicitudesPasajeros: Response
      }
    })
    return Response
  }).catch(Error => {
    return Error
  })
}
export const aceptPasajeroAction = ({ IdSolicitud }) => async (dispatch) => {
  return await putPasajeroAcept({ IdSolicitud }).then(Response => {
    dispatch({
      type: PUT_CAMBIOS_PASAJERO_DISPONIBLE,
      payload: {
        exito: 1
      }
    })
    return Response
  }).catch(Error => {
    return Error
  })
}
export const declinePasajeroAction = ({ IdSolicitud }) => async (dispatch) => {
  return await putPasajeroDecline({ IdSolicitud }).then(Response => {
    dispatch({
      type: PUT_CAMBIOS_PASAJERO_NO_DISPONIBLE,
      payload: {
        exito: 1
      }
    })
    return Response
  }).catch(Error => {
    return Error
  })
}
/**
 *  TODO: Clear state
 */
export const clearState = () => async (dispatch) => {
  dispatch({
    type: CLEAR_STATE,
    payload: dataInicial
  })
}
/**
 *  TODO: Obtener cotizacion
 */
export const obtenerCotizacionAction = ({ Referencia }) => async (dispatch) => {
  return await getContratacionReferencia({ Referencia }).then(Response => {
    dispatch({
      type: GET_CAMBIOS_COTIZACION,
      payload: {
        cotizacion: Response
      }
    })
    return Response
  }).catch(Error => {
    return Error
  })
}
export const obtenerComprasAction = ({ IdPaquete }) => async (dispatch) => {
  return await getComprasItemsPaquete({ IdPaquete }).then(Response => {
    dispatch({
      type: GET_CAMBIOS_COMPRAS,
      payload: {
        compras: Response
      }
    })
    return Response
  }).catch(Error => {
    return Error
  })
}